<div
  style="
    background: url('../../../../../assets/images/news/rating-star-empty.png');
    background-size: 20px 18px;
    background-repeat: no-repeat;
    height: 18px;
    width: 20px;
    position: absolute;
  "
></div>
<div
  [ngStyle]="{ width: fillWidth }"
  style="
    background: url('../../../../../assets/images/news/rating-star-full.png');
    background-size: 20px 18px;
    background-repeat: no-repeat;
    height: 18px;

    position: absolute;
  "
></div>
